<div class="modal-header">
    <h3>Reset Approvers</h3>
</div>
<div class="modal-body">
    <p>This action will reset all existing approvals and regenerate the approval steps based on the currently assigned reviewers. To update only the line currently selected, choose "Reset Approvers on Selected Line." To update all receipt lines on the associated receipt, choose "Reset Approvers on Receipt."</p>
</div>
<div class="modal-footer">
    <button type="button" id="receipt" class="btn btn-success"
            (click)="onClick(false)">
        Reset Approvers on Receipt
    </button>
    <button type="button" id="receiptItem" class="btn btn-success"
            (click)="onClick(true)">
        Reset Approvers on Selected Line
    </button>
    <button type="button" class="btn btn-outline-dark"
            (click)="cancelClicked()">
        Cancel
    </button>
</div>
